import React from "react";

const Cancel = () => {
  return <div>Payment cancelled. Please close this window.<script>setTimeout(function(){window.close()},100);</script></div>;
};

export default Cancel;
